import api from "./../api/axios";
import endpoints from "./../api/endpoints";



export const getCookies = async () => {
    return await api.get(endpoints.cookies.post);
}

export const postCookies = async () => {
    return await api.post(endpoints.cookies.post);
}